import { IdentifierCode } from '@quromedical/fhir-common';

export const IdentifierCodeDisplay: Record<IdentifierCode, string> = {
  [IdentifierCode.deviceType]: 'Device Type',
  [IdentifierCode.passportNumber]: 'Passport Number',
  [IdentifierCode.registrationNumber]: 'Registration Number',
  [IdentifierCode.serviceRequestPerformer]: 'Request Performer',
  [IdentifierCode.southAfricanIdNumber]: 'South African ID Number',
  [IdentifierCode.namibianIdNumber]: 'Namibian ID Number',
  [IdentifierCode.encounterHospitalizationDependentCode]:
    'Medical Aid Dependant Code',
  [IdentifierCode.encounterHospitalizationSchemeCode]:
    'Medical Aid Scheme Code',
  [IdentifierCode.encounterHospitalizationSubscriberId]: 'Medical Aid Number',
  [IdentifierCode.encounterMedicalAidAuthorizationCode]:
    'Medical Aid Authorization Code',
  [IdentifierCode.encounterMedicalAidAuthorizationDate]:
    'Medical Aid Authorization Date',
  [IdentifierCode.organizationSchemeCode]: 'Medical Aid Scheme Code',
  [IdentifierCode.claimInvoiceNumber]: 'Invoice number',
  [IdentifierCode.medicationStatementGroupIdentifier]: 'Prescription',
  [IdentifierCode.medicationRequestGroupIdentifier]: 'Prescription',
  [IdentifierCode.ampathMnemonic]: 'Ampath Mnemonic',
  [IdentifierCode.chargeItemConsumableCode]: 'Consumable Code',
  [IdentifierCode.conversation]: 'Conversation SID',
  [IdentifierCode.dependantCode]: 'Medical Aid Dependant Code',
  [IdentifierCode.membershipNumber]: 'Medical Aid Membership Number',
  [IdentifierCode.schemeCode]: 'Medical Aid Scheme Code',
  [IdentifierCode.locationCapacity]: 'Location Capacity Code',
  [IdentifierCode.locationAcuity]: 'Location Acuity Ward Code',
  [IdentifierCode.conversationMessageType]: 'Conversation Message Type',
  [IdentifierCode.conversationParticipant]: 'Conversation Participant',
  [IdentifierCode.conversationMessage]: 'Conversation Message SID',
  [IdentifierCode.conversationAlert]: 'Conversation Alert',
  [IdentifierCode.carePlanActivityDate]: 'Activity Date',
  [IdentifierCode.libraryTemplateId]: 'Template ID',
  [IdentifierCode.patientMasterIndexId]: 'Patient Master Index ID',
  [IdentifierCode.schemeShortName]: 'Medical Aid Scheme Short Name',
};
